module.exports = __webpack_public_path__ + "media/images/icon/breadcrumb/arrow-9a437001b22bf73de40c89e9f079f1cc.png";